"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FundManagerPlaceholder_svg_1 = __importDefault(require("../../assets/images/FundManagerPlaceholder.svg"));
/* [AddAsset: import] */


exports.managementAssets = {
  fundManager: {
    placeholder: FundManagerPlaceholder_svg_1.default
  }
};